"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queued = void 0;
const utils_1 = require("../utils");
function queued(api, delayBetweenRuns = 100) {
    const q = (0, utils_1.asyncQueue)({
        delayBetweenRuns,
    });
    const proxy = new Proxy(api, {
        get(target, propKey, receiver) {
            const targetValue = Reflect.get(target, propKey, receiver);
            if (typeof targetValue === "function") {
                return function (...args) {
                    return q.submit(() => targetValue.apply(this, args));
                };
            }
            else {
                return targetValue;
            }
        },
    });
    return proxy;
}
exports.queued = queued;
//# sourceMappingURL=queued.js.map